<template>
  <div class="container mycontainer">
    <h1 class="style-h3">Mentions légales</h1>
    <div class="row">
      <div class="col-12">
        <p>
          Conformément aux dispositions de la loi n° 2004-575 du 21 juin 2004
          pour la confiance en l’économie numérique, il est précisé aux
          utilisateurs du site
          <a
            class="c4"
            href="https://www.google.com/url?q=http://oforis.com&amp;sa=D&amp;ust=1604773488478000&amp;usg=AOvVaw0QbQ29JXl-OUA4hylHXERJ"
            >oforis.com</a
          >
          l’identité des différents intervenants dans le cadre de sa réalisation
          et de son suivi.
        </p>
      </div>
      <div class="col-12">
        <h4>Edition du site</h4>
        <p>
          Le site
          <a
            class="c4"
            href="https://www.google.com/url?q=http://oforis.com&amp;sa=D&amp;ust=1604773488478000&amp;usg=AOvVaw0QbQ29JXl-OUA4hylHXERJ"
            >oforis.com</a
          >
          est édité par la société <b>Heimdall</b>, société par actions
          simplifiée au capital de 1000 euros, dont le siège social est situé
          <b>28 Avenue des Ajoncs 64600 ANGLET </b>immatriculée au registre du
          commerce et des sociétés sous le numéro d’identification unique
          <b>32719924600015</b> R.C.S. : au <b>RCS de Bayonne</b>.
        </p>
        <h4>Responsable du site</h4>
        <p><span>ASSELINEAU Kirwan</span></p>
        <h4>Hébergeur</h4>
        <p>
          Le site oforis.com est hébergé par la société Google Cloud Platform,
          dont le siège est situé à l'adresse ci-après :
        </p>

        <p><b>8 rue de Londres 75009 Paris</b></p>

        <p><b>Numéro de téléphone : 0805 980345</b></p>
        <p>
          Le stockage des données personnelles des Utilisateurs est
          exclusivement réalisé sur les centre de données (« clusters »)
          localisés dans des Etats membres de l’Union Européenne de la société
          Google
        </p>
        <h4>Nous contacter</h4>
        <p>Par email : oforis.contact@gmail.com</p>
      </div>
      <div class="col-12">
        <h4>CNIL</h4>
        <p>
          La société Oforis conservera dans ses systèmes informatiques et dans
          des conditions raisonnables de sécurité une preuve de la transaction
          comprenant le bon de commande et la facture.
        </p>
        <p>
          Conformément aux dispositions de la loi 78-17 du 6 janvier 1978
          modifiée, l’Utilisateur dispose d’un droit d’accès, de modification et
          de suppression des informations collectées par Oforis. Pour exercer ce
          droit, il reviendra à l’Utilisateur d’envoyer un message à l’adresse
          suivante : oforis.contact@gmail.com
        </p>
      </div>
    </div>
  </div>
</template>
<script>
export default {};
</script>
<style lang="scss">
#home {
  background-color: #11ffee00;
}
</style>